import { Injectable } from '@angular/core';

@Injectable()
export class SessionSteps {

  bookingComponents: Array<{}>;
  introPages: Array<{}> = ['SignUpPage', 'IntroductionPage', 'LoginPage'];

  constructor () {}

  storeBookingStep(componentName): void {
    localStorage.setItem('lastStep', componentName);
  }

  isNewRelease(componentName): boolean {
    const cmRelease = localStorage.getItem('cm_release');

    return this.introPages.indexOf(componentName) === -1
              && cmRelease !== 'newSb'
  }

  getLastStep() {
    return localStorage.getItem('lastStep');
  }

  isAllowedPage(page): boolean {
    return page !== 'SignUpPage';
  }

  clearBookingStep(): void {
    localStorage.removeItem('myHouseCreated');
    localStorage.removeItem('lastStep');
  }

}
